export default "__VITE_ASSET__BOJBOv7o__"